<div class="content-left-top-cornor">
  <p-blockUI>
    <div id="center" style="margin-top:260px; margin-left:800px;">
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
  </p-blockUI>

  <div>
    <p-tabView>
      
      <p-tabPanel header="Run Planning">
        <app-run-planning #runPlanning></app-run-planning>
      </p-tabPanel>

      <p-tabPanel header="Run Scheduling">
      <app-run-scheduling #runScheduling></app-run-scheduling>
      </p-tabPanel>
      
      <p-tabPanel header="Run Processing">
        <app-run-processing #runProcessing></app-run-processing>
      </p-tabPanel>
      
    </p-tabView>
  </div>
</div>